import { render, staticRenderFns } from "./registerSteps.vue?vue&type=template&id=024bdfd7&scoped=true&"
import script from "./registerSteps.vue?vue&type=script&lang=js&"
export * from "./registerSteps.vue?vue&type=script&lang=js&"
import style0 from "./registerSteps.vue?vue&type=style&index=0&id=024bdfd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024bdfd7",
  null
  
)

export default component.exports